<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16rKx2M/tc-custom/9781631942730.jpg?1708805196371" alt="This image is the cover for the book Roderick Alleyn Mysteries Volume 3, Roderick Alleyn"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Roderick Alleyn Mysteries Volume 3, Roderick Alleyn
      </h1>
      <p class="bookDescription body article font2">
        <b>Three witty novels by</b> <b>“the finest writer in the English language of the pure, classical puzzle whodunnit” (<i>The Sun</i>).</b><br/>  <br/> This volume includes three books in the Golden Age detective series from the Mystery Writers of America Grand Master:<br/>  <br/><b><i>Death in a White Tie</i></b>: A high-society homicide is the talk of the London season: “Marsh’s writing is a pleasure.” —<i>The Seattle Times</i><br/>  <br/><b><i>Overture to Death</i></b><i>:</i> In a Dorset village, a snobby local busybody is silenced for good in this tale by “a peerless practitioner of the slightly surreal, English-village comedy-mystery” (<i>Kirkus Reviews</i>).<br/>  <br/><b><i>Death at the Bar</i></b>: A famous barrister is enjoying a pint at the pub—until a dart becomes a deadly weapon . . .<br/>  <br/> “In her ironic and witty hands the mystery novel can be civilized literature.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ngaio Marsh
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f2eaabc